import { AuthVerifyPage } from '@/app/pages/auth/auth-verify';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/auth/verify')({
  validateSearch: z.object({
    redirectTo: z.string().optional(),
    travelId: z.string().uuid().optional(),
  }),
  component: AuthVerifyPage,
});
